export default "__VITE_ASSET__DaRn9fvE__"